import { Role } from '@nicejob-library/enums';

export const PAYSTONE_DOMAIN = 'paystone.com';
export const GIVEPOINT_URL = `https://givepoint.${PAYSTONE_DOMAIN}`;

/** Dummy email to attach paystone hub companies that don't user */
export const PAYMENTS_HUB_ORPHAN_COMPANY_USER_EMAIL = 'paystone-dummy-user-xpazijl@paystone.com';
export const USER_ROLES_WITH_ACCESS_TO_PAYMENT_REPORTING = [Role.OWNER, Role.MANAGER_PLUS_PAYMENT];
